var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"onclick":"window.print();return false","title":_vm.$t('print')}},[_c('fa',{staticClass:"text-primary hover-darken cursor-pointer",attrs:{"icon":_vm.icons.print}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }